import { expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
import React, { useEffect, useState } from 'react'
import configData from "../../../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput
} from 'reactstrap';

import Megafono from "assets/icons/megafono.png"
import "./SolicitudAcumulaDecimos.scss"

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardSolicitudAcumulaDecimos from "components/Varios/CardSolicitudAcumulaDecimos.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../../../services/authentication.service';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

const id = 1043;
const API_URL = configData.SERVER_URL;
let tieneRestriccion = false;

export class SolicitudAcumulaDecimosData {
    idotrosdocumentos: number = 0;
    idpersona: number = 0;
    tipodoc: string = "";
    codigodocumento: string = "";
    refdoc: string = "";
    fecharegistro?: string = "";
    estado: string = "";
    Estadorevisionth: number = 0;
}

export class SolicitudAcumulaDecimosFechas {
    fechadesde: string = "";
    fechahasta: string = "";
}

interface SolicitudAcumulaDecimosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: SolicitudAcumulaDecimosData;
    SolicitudAcumulaDecimosList: SolicitudAcumulaDecimosData[];
    tipoSolicitudList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    dtoFechas: SolicitudAcumulaDecimosFechas;
}

export class SolicitudAcumulaDecimos extends React.Component<RouteComponentProps, SolicitudAcumulaDecimosDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new SolicitudAcumulaDecimosData(),
            SolicitudAcumulaDecimosList: [], tipoSolicitudList: [], error: null, tiposEvidencia: [], filesData: [], dtoFechas: new SolicitudAcumulaDecimosFechas(),
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarSolicitudAcumulaDecimos = this.cargarSolicitudAcumulaDecimos.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.cargarFechas = this.cargarFechas.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarFechas();
                    this.cargarDatos();
                    this.cargarSolicitudAcumulaDecimos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        if (!expresion_civil(authenticationService.currentUserValue.regimen_usuario))
            tieneRestriccion = true;

        fetch(API_URL + "SolicitudAcumulaDecimos/SolicitudAcumulaDecimosCatalogo")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoSolicitudList: result.entTabla.map(d => ({
                                "value": d.codigodocumento,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoSolicitudList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSolicitudAcumulaDecimos() {
        this.setState({
            loading: false,
            loadingList: false
        });
        fetch(API_URL + "SolicitudAcumulaDecimos/SolicitudAcumulaDecimosDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            SolicitudAcumulaDecimosList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        SolicitudAcumulaDecimosList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarFechas() {

        fetch(API_URL + "SolicitudAcumulaDecimos/SolicitudAcumulaDecimosFechas")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let _dtoFechas = new SolicitudAcumulaDecimosFechas();
                        _dtoFechas["fechadesde"] = result.entTabla[0].fechadesde;
                        _dtoFechas["fechahasta"] = result.entTabla[0].fechahasta;

                        if ((new Date()).getTime() > (new Date(result.entTabla[0].fechahasta + "T23:59:59")).getTime())
                            alertService.error("El período de ingreso de datos en esta opción no está disponible.");

                        this.setState({
                            dtoFechas: _dtoFechas
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los datos.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoSolicitudList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        if (name == "codigodocumento")
            dto["tipodoc"] = value;

        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });
    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "IDI", "label": "" + filesData.filter(f => f.type == "IDI").map(ff => ': ' + ff.file.name).join(', ') },
        ];
        return tiposEvidencia;
    }

    descargarEvidencias(solicitudacumuladecimos: SolicitudAcumulaDecimosData) {
        var evidencias = new Array();
        if (solicitudacumuladecimos.refdoc) {
            evidencias.push({ name: "S-" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "SolicitudAcumulaDecimos/Refarchivo/" + solicitudacumuladecimos.idotrosdocumentos });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new SolicitudAcumulaDecimosData() });
    }

    onClickDelete(idotrosdocumentos) {
        fetch(API_URL + "SolicitudAcumulaDecimos/DeleteSolicitudAcumulaDecimos/" + idotrosdocumentos, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La solicitud se anuló correctamente.")
                        this.cargarSolicitudAcumulaDecimos();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append("files", fileData.file, fileData.file.name);
            });

            formFilesData.append('identidad', identidad);

            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar las evidencias.")
                        }
                        else if (responseJson["strEstado"] === "S") {
                            alertService.success("La evidencia se cargaron exitosamente");
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });

        dto.idpersona = this.state.currentUser.idpersona;
        delete dto['fecharegistro'];

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idotrosdocumentos == 0) {
                fetch(API_URL + "SolicitudAcumulaDecimos/PostSolicitudAcumulaDecimos", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson["strMensaje"])
                                this.onClickLimpiar();
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La solicitud se ha registrado correctamente.");

                                this.cargarSolicitudAcumulaDecimos();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : (!tieneRestriccion) ? <div>LO SENTIMOS, NO PUEDE REALIZAR ACCIONES EN ESTA SECCIÓN</div> : this.renderForm(this.state.SolicitudAcumulaDecimosList, this.state.tipoSolicitudList, this.state.tiposEvidencia, this.state.dtoFechas);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.

    private renderForm(SolicitudAcumulaDecimosList: Array<any>, tipoSolicitudList: Array<any>, tiposEvidencia: Array<any>, fechas: SolicitudAcumulaDecimosFechas) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Acumulación / Mensualización Décimos &nbsp; <a href="https://talentohumano.espol.edu.ec/Sitio/archivos/GUI-DHO-006_guia_solicitar_decimos.pdf" target="_blank">
                                    <img
                                        src={PdfSVG}
                                        className="acciones"
                                        alt="Guía para solicitar acumulación o mensualización de décimos"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Guía para solicitar acumulación o mensualización de décimos"
                                        style={{ width: 24, height: 24 }}
                                    />
                                </a></h5>
                                
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <Row>
                                        <Col md={12}>
                                            <div className="alertaSolicitudAcumulaDecimos">
                                                <div className="cabecera">
                                                    <img src={Megafono} className="icono" /><b> AVISO IMPORTANTE </b>
                                                </div>
                                                <div><b><i>{`En el Acuerdo Ministerial Nº MCT.2015-0087, emitido por el Ministerio de Trabajo se establece:`}</i></b></div>
                                                <div><b><i>{`Art 4 . Solicitud de acumulación.- `}</i></b><i>{`Para efectos de la solicitud de la decimotercera y/o decimocuarta remuneración, los trabajadores deberán presentarla por escrito a sus respectivos empleadores, durante los quince primeros días del mes de enero. Si para años posteriores el trabajador deseare continuar recibiendo de manera acumulada su decimotercera y/o decimocuarta remuneración según corresponda no será necesaria la presentación de una nueva solicitud. No se podrá presentar una solicitud para cambio de la modalidad de pago, sino dentro de los quince primeros días del mes de enero del siguiente año.`}</i></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col md={12}>
                                            <div className="alertaSolicitudAcumulaDecimos">
                                                <div><i>{`Si desea cambiar la modalidad de pago de la decimotercera y/o decimocuarta remuneración, enviar la solicitud hasta el 20 de Enero.`}</i></div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <br />
                                    {(new Date()).getTime() < (new Date(fechas.fechahasta + "T23:59:59")).getTime() ?
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={4}>
                                                <Label for="codigodocumento">Nueva Solicitud*</Label>
                                                <SelectItem
                                                    options={tipoSolicitudList}
                                                    value={this.state.dtoData.codigodocumento}
                                                    onChange={this.handleSelectChange}
                                                    placeholder=""
                                                    name="codigodocumento"
                                                    id="codigodocumento"
                                                    icon="fa-caret-right"
                                                />
                                            </Col>
                                        </Row>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "left" }}>Aceptar y Enviar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form>
                                        : ('') }
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {SolicitudAcumulaDecimosList.map((dto, index) =>
                                                <CardSolicitudAcumulaDecimos
                                                    key={dto.idotrosdocumentos}
                                                    objeto={dto}
                                                    objetofechas={this.state.dtoFechas}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + SolicitudAcumulaDecimosList.length}
                                                    eventDelete={() => this.onClickDelete(dto.idotrosdocumentos)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default SolicitudAcumulaDecimos;
